export class ScheduleSerie {
    public id: number;
    public scheduleId: number;
    public nit: string;
    public datePurchase: Date;
    public datePurchase1: string;
    public mark: string;
    public model: string;
    public colour: string;
    public imei: string;
    public cover: string;
    public battery: string;
    public loader: string;
    public memoryRemovable: string;
    public freeHand: string;
    public other: string;
    public failure: string;
    public schedule: string;

    constructor() {}
}
